import React, { useState, useEffect } from 'react';
import styles from './CreateSite.module.scss';
import classNames from 'classnames';
import CreateSiteForm from '../../../forms/CreateSiteForm/CreateSiteForm'
import { IUserSite, ISite, db } from '../../../database';

type CreateSiteProps = {
  status?: string,
  close: () => void;
  triggerCheckToClose: boolean;
  onCloseConfirmed: () => void;
  openTab: (tabType: string) => void;
  placePin: () => void;
  site?: IUserSite | undefined;
  doUpdate: () => void;
  markerPosition: {
    latitude: number,
    longitude: number
  }
}

const CreateSite: React.FC<CreateSiteProps> = ({status, onCloseConfirmed, triggerCheckToClose, doUpdate, close, openTab, placePin, site, markerPosition}) => {
  const [siteTouched, setSiteTouched] = useState(false);
  const [resetValues, setResetValues] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const [loadedSite, setLoadedSite] = useState(site);
  const checkToClose = () => {
    if(siteTouched || triggerCheckToClose === true) {
      setConfirmClose(true);
    } else {
      setResetValues(true);
      close();
    }
    onCloseConfirmed();
  }

  useEffect(() => {
    if (triggerCheckToClose) {
      checkToClose();
    }
  }, [triggerCheckToClose])

  useEffect(() => {
    const loadSavedFormDetails = async () => {
      if(site){
        const savedSite = await db.savedUserSites.get(site.userSiteId);
        if(savedSite){
          setLoadedSite({
            ...site,
            route: savedSite.route,
            name: savedSite.name,
            altName: savedSite.altName,
            operationalStatus: savedSite.operationalStatus,
            siteType: savedSite.siteType,
            address: savedSite.address ? savedSite.address : '',
            postcode: savedSite.postcode,
            elr: savedSite.elr,
            mileage: savedSite.mileage,
            latitude: savedSite.latitude,
            longitude: savedSite.longitude,
            photos: savedSite.photos,
            comments: savedSite.comments
          })
        } else {
          setLoadedSite(site);
        }
      }
    }
    loadSavedFormDetails();
  }, [site])

  const addSiteClass = styles.AddSite + ' ' + (status === 'AddSite' ? styles.AddSiteVisible : styles.AddSiteHidden)
  return(
  <>
    <div className={classNames(styles.closeFormMessage, {
      [styles.closeFormMessageEnter]: confirmClose,
    })}>
      <p>Navigating away will result in the loss of unsaved data. Are you sure you want to quit?</p>
      <button onClick={() => {
        setConfirmClose(false);
        setResetValues(!resetValues);
        openTab('default');
        close()
        }}>Okay</button>
      <button onClick={() => setConfirmClose(false)}>Cancel</button>
    </div>
    <div className={addSiteClass}>
      <div className={styles.CloseButton} onClick={() => {checkToClose()}} />
      <CreateSiteForm
        doUpdate={doUpdate}
        resetValues={resetValues}
        setTouched={(touched: boolean) => setSiteTouched(touched)}
        close={() => close()}
        closeForm={() => openTab('viewSite')}
        site={loadedSite}
        editSite={site ? true : false}
        openTab={(tab) => openTab(tab)}
        placePin={() => {placePin()}}
        markerPosition={markerPosition}
      />
    </div>
  </>
  )
}

export default CreateSite;
